export const optimizedHallFeatureFlagEnable = true;

export default function isOptimizedHallFeatureFlag(optimizedHall) {
    return !!optimizedHall && optimizedHallFeatureFlagEnable;
}
